<template>
  <w-button
    fluid
    class="form-aside-button"
    radius="square"
    text-align="left"
    variant="ghost"
    :size="size"
    :class="active ? 'form-aside-button--active' : undefined"
    @click="$emit('tabSelected', tab.name)"
  >
    <w-flex fluid class="form-aside-button__content">
      <w-flex class="form-aside-button__number"> {{ index + 1 }}.</w-flex>

      <w-flex class="form-aside-button__title"> {{ tab.title }} </w-flex>
    </w-flex>
  </w-button>
</template>

<script setup lang="ts">
import type { SizeType } from '@witkac/vue3-components';

import type { Tab } from '@/typings/tab';

withDefaults(
  defineProps<{
    index: number;
    tab: Tab;
    active: boolean;
    size?: SizeType;
  }>(),
  {
    size: 'sm',
  },
);
</script>

<style lang="scss">
.form-aside-button {
  opacity: 0.5;

  &__number,
  &__title {
    transition: w.transition('x-fast') w.ease('out-expo');
  }

  &--active {
    opacity: 1;
    .form-aside-button {
      &__title {
        text-decoration: underline;
        text-decoration-color: w.color('neutral', 700);
        text-underline-offset: 4px;
      }
    }
  }

  &__number {
    min-width: 24px;

    @include w.media-xl {
      min-width: 20px;
    }

    @include w.media-lg {
      min-width: 16px;
    }
  }
}
</style>
